<i18n>
  {
    "en": {
      "TourIsReadyHeader": "Your virtual tour is ready!",
      "PossibleNextSteps": "Possible next steps:",
      "Step1ViewOnGoogleMaps": "1. View the tour on Google Maps",
      "Step1Note": "You should also be able to see the tour's panoramas on your {businessPage} on Google Maps (in the {photos} section).",
      "Step1BusinessPage": "business page",
      "Step1Photos": "photos",
      "Step2Embed": "2. Embed the tour into your website",
      "Step2Note": "The code above will embed a 600x450 virtual tour on your website. If you want either a different tour location or a different embedded window size, please follow these instructions:",
      "Step2OpenOnGoogleMaps": "Open the tour on Google Maps",
      "Step2Instruction1": "Navigate to the point you like and position the camera the way you like.",
      "Step2Instruction2": "In the top left corner click on a little {icon} icon.",
      "Step2Instruction3": "Select {shareOrEmbedImage}.",
      "Step2Instruction3ShareOrEmbedImage": "Share or Embed Image",
      "Step2Instruction4": "Select {embedMap}.",
      "Step2Instruction4EmbedMap": "Embed a map",
      "Step2Instruction5": "Configure the widget the way you see fit and copy the HTML code.",
      "ContactMe": "Please contact me in case you have any questions!"
    },
    "de": {
      "TourIsReadyHeader": "Ihre virtuelle Tour ist online!",
      "PossibleNextSteps": "Mögliche nächste Schritte:",
      "Step1ViewOnGoogleMaps": "1. Sie können sich die Tour in Google Maps ansehen",
      "Step1Note": "Sie sollten auch in der Lage sein, die Panoramen der Tour auf Ihrer {businessPage} in Google Maps (im {photos} bereich) anzeigen zu lassen.",
      "Step1BusinessPage": "Unternehmensseite",
      "Step1Photos": "Fotos oder 360-Ansichten",
      "Step2Embed": "Betten Sie die Tour in Ihre Website ein",
      "Step2Note": "Mit dem obigen Code wird eine virtuelle 600x450-Tour auf Ihrer Website eingebettet. Wenn Sie einen anderen Tourstandort oder eine andere Größe des eingebetteten Fensters wünschen, befolgen Sie bitte diese Anweisungen:",
      "Step2OpenOnGoogleMaps": "Öffnen Sie die Tour auf Google Maps",
      "Step2Instruction1": "Navigieren Sie mit dem Mauszeiger zu einem beliebigen Punkt und positionieren Sie die Kamera so, wie Sie möchten.",
      "Step2Instruction2": "Klicken Sie oben links auf ein kleines {icon} Symbol.",
      "Step2Instruction3": "Wählen Sie {shareOrEmbedImage}.",
      "Step2Instruction3ShareOrEmbedImage": "Bild teilen oder einbetten",
      "Step2Instruction4": "Wählen Sie {embedMap}.",
      "Step2Instruction4EmbedMap": "Karte einbetten",
      "Step2Instruction5": "Konfigurieren Sie das Widget nach Ihren Wünschen und kopieren Sie den HTML-Code.",
      "ContactMe": "Bitte kontaktieren Sie mich bei Fragen!"
    }
  }
</i18n>
<template>
  <div class="container outer" v-if="work">
    <div class="row">
      <div class="col-12">
        <b-jumbotron :header="$t('TourIsReadyHeader')">
          <div class="d-flex flex-wrap align-items-stretch address-panel">
            <div
              class="preview-image"
              :style="{backgroundImage: 'url(\'' + work.previewImageURL + '\')'}"
            ></div>
            <address class="mt-3 d-block">
              <strong>{{work.placeMetadata.name}}</strong>
              <br>
              {{work.placeMetadata.vicinity}}
            </address>
          </div>

          <p>{{ $t('PossibleNextSteps') }}</p>
          <div class="d-flex flex-column">
            <h4>{{ $t('Step1ViewOnGoogleMaps') }}</h4>
            <div class="mt-3">
              <copy-link :url="googleMapsURL"></copy-link>
            </div>

            <br>
            <i18n path="Step1Note" tag="p">
              <a place="businessPage" class="text-info" :href="myBusinessURL" target="_blank">{{ $t('Step1BusinessPage') }}</a>
              <em place="photos">{{ $t('Step1Photos') }}</em>
            </i18n>

            <br>
            <h4>{{ $t('Step2Embed') }}</h4>
            <copy-text :text="work.embedCode"></copy-text>
            <br>
            <p>{{ $t('Step2Note') }}</p>
            <ol>
                <li><a
                    :href="googleMapsURL"
                    class="text-info"
                    target="_blank"
                  >{{ $t('Step2OpenOnGoogleMaps') }}</a>
                </li>
                <li>{{ $t('Step2Instruction1') }}</li>
                <i18n path="Step2Instruction2" tag="li">
                  <span place="icon">&nbsp;&nbsp;<font-awesome-icon :icon="['fas', 'ellipsis-v']"></font-awesome-icon>&nbsp;&nbsp;</span>
                </i18n>
                <i18n path="Step2Instruction3" tag="li">
                  <em place="shareOrEmbedImage">{{ $t('Step2Instruction3ShareOrEmbedImage') }}</em>
                </i18n>
                <i18n path="Step2Instruction4" tag="li">
                  <em place="embedMap">{{ $t('Step2Instruction4EmbedMap') }}</em>
                </i18n>
                <li>{{ $t('Step2Instruction5') }}</li>
            </ol>

            <div class="additional-link" v-for="(url, index) in additionalURLs" :key="index">
              <br>
              <h4>{{ index + 3 }}. {{ url.text }}</h4>
              <a class="text-info" :href="url.url" target="_blank">{{ url.url }}</a>
            </div>

            <div class="additional-text" v-for="(text, index) in additionalTexts" :key="index">
              <br>
              <p class="pre">{{ text.text }}</p>
            </div>

            <div class="additional-picture" v-for="(picture, index) in additionalPictures" :key="index">
              <br>
              <h4 v-if="picture.text">{{ picture.text }}</h4>
              <img class="additional-picture mb-4" :src="picture.pictureURL">
            </div>
          </div>

          <div class="contact-panel">
            <p>{{ $t('ContactMe') }}</p>
            <p>
              <span>Olga Bushkova</span>
              <br>
              <a class="text-info" href="mailto:contact@bushkova.ch">contact@bushkova.ch</a>
              <br>
              <a class="text-info" href="tel:+41786744065">+41 (0) 78 674 4065</a>
            </p>
          </div>
        </b-jumbotron>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import '../bootstrap-overrides';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/_breakpoints';

.address-panel {
  margin-top: 3em;
  margin-bottom: 2em;
  background-color: white;

  .preview-image {
    min-width: 200px;
    height: auto;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
}

.contact-panel {
  margin-top: 2em;
}

address {
  padding-left: 1em;
  font-size: 2rem;
}

.outer {
  button {
    &.menu-button {
      margin-top: 1em;
    }
    white-space: normal;
  }
  
  a {
    text-decoration: underline;
  }
}

.mapLinkCombo {
  @include media-breakpoint-down(md) {
    margin-top: 0.5em;
  }
}

p.pre {
  white-space: pre;
}

.additional-link {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
}

img.additional-picture {
  max-width: 100%;
  margin-top: 0.5em;

  @include media-breakpoint-up(md) {
    max-height: 600px;
  }
}

</style>
<script>
import UserApi from '@/user-api';

export default {
  name: 'home',
  data() {
    return {
      work: undefined
    };
  },
  computed: {
    myBusinessURL() {
        return `https://www.google.com/maps/search/?api=1&query=${this.work.placeMetadata.name}&query_place_id=${this.work.placeMetadata.place_id}`;
    },

    googleMapsURL() {
      const embedURL = new URL(this.work.previewSrc);
      let resultURL = 'https://www.google.com/maps/@?api=1&map_action=pano';
      for (let [name, value] of embedURL.searchParams.entries()) {
        if (name === 'pano' || name === 'heading' || name === 'pitch' || name === 'key') {
          resultURL += `&${name}=${value}`;
        }
      }

      return resultURL;
    },

    unlistedItems() {
      if (this.work.unlistedData && this.work.unlistedData.items) {
        return this.work.unlistedData.items;
      } else {
        return [];
      }
    },

    additionalURLs() {
      return this.unlistedItems.filter(i => i.type === 'url');
    },

    additionalTexts() {
      return this.unlistedItems.filter(i => i.type === 'text');
    },

    additionalPictures() {
      return this.unlistedItems.filter(i => i.type === 'picture');
    },
  },
  beforeMount() {
    const id = this.$router.currentRoute.params.id;
    const unlistedId = this.$router.currentRoute.query.uid;

    UserApi.getWorkById(id).then(work => {
      if (unlistedId) {
        UserApi.getWorkUnlistedDataById(id, unlistedId).then(unlistedData => {
          this.work = {unlistedData, ...work};
        });      
      } else {
        this.work = work;
      }
    });
  }
};
</script>